import React, { useState } from "react";
import { CreateUserForm, EditUserForm, UsersTable } from "components/Users";
import { Navigation } from "components/Navigation";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import PrivateRoute from "PrivateRoute";
import { Login } from "components/Login";
import {
  CreateOrder,
  EditOrder,
  OrderEditHistory,
  OrdersTable,
} from "components/Order";
import { CreateCarForm } from "components/Car/CreateCarForm";
import { EditCarForm } from "components/Car/EditCarForm";
import { CarsTable } from "components/Car/CarTable";
import { DriverDetails, DriversTable } from "components/Drivers";
import { CreateDriverForm } from "components/Drivers/CreateDriverForm";
import { EditDriverForm } from "components/Drivers/EditDriverForm";
import { makeStyles } from "@material-ui/core/styles";
import { OrdersDetails } from "components/Order/OrderDetails/OrderDetails";
import { CarDetails } from "components/Car/Details";
import { MyProfile } from "components/Users/Details/MyProfile";
import { AdminUserDetailsView } from "components/Users/Details/AdminUserDetailsView";
import { DriverOnBoardingScreen } from "components/DriverOnBoardingScreen";
import { useMediaQuery } from "react-responsive";
import { MobileNavigation } from "components/MobileNavigation";
import { NotificationDialog } from "components/Notification";
import classNames from "classnames";
import { getNavigationExpandedFromLocalStorage } from "components/Navigation/preferences";
import {
  ContractorDetails,
  ContractorEditHistory,
  ContractorsTable,
  CreateContractorForm,
  EditContractorForm,
} from "components/Contractors";
import {
  FerryServiceCreateForm,
  FerryServiceDetails,
  FerryServiceEditForm,
  FerryServicesTable,
} from "components/FerryServices";
import {
  CreateInsurancePolicyForm,
  EditInsurancePolicyForm,
} from "components/Contractors/InsurancePolicy";
import { CustomFieldsTable } from "components/CustomFields";
import { CustomFieldsCreateForm } from "components/CustomFields/CustomFieldsForm/CustomFieldsCreateForm";
import { CustomFieldsEditForm } from "components/CustomFields/CustomFieldsForm/CustomFieldsEditForm";
import { UserGroupsTable } from "components/UserGroups";
import {
  UserGroupsCreateForm,
  UserGroupsEditForm,
} from "components/UserGroups/UserGroupsForm";
import { GroupsTable } from "components/Groups";
import { GroupsCreateForm, GroupsEditForm } from "components/Groups/GroupsForm";
import {
  GLOBAL_CONFIGURATION_WRITE,
  CAR_CREATE,
  CAR_EDIT,
  CAR_READ,
  CONTRACTOR_CREATE,
  CONTRACTOR_EDIT,
  CONTRACTOR_READ,
  CUSTOM_FIELDS_READ,
  DRIVER_CREATE,
  DRIVER_EDIT,
  DRIVER_READ,
  FERRY_SERVICE_CREATE,
  FERRY_SERVICE_EDIT,
  FERRY_SERVICE_READ,
  GROUP_CREATE,
  GROUP_EDIT,
  GROUP_READ,
  MY_PROFILE_READ,
  ORDER_CREATE,
  ORDER_EDIT,
  ORDER_HISTORY_READ,
  ORDER_READ,
  useAuth,
  USER_CREATE,
  USER_EDIT,
  USER_GROUP_CREATE,
  USER_GROUP_EDIT,
  USER_GROUP_READ,
  USER_READ,
} from "context/auth";
import { MainPage } from "components/Main/Main";
import UserRole from "constants/UserRole";
import { AdminPanelDetails } from "./components/AdminPanel/Details";
import {AdminPanelForm} from "./components/AdminPanel/AdminPanelForm";

const drawerWidth = 270;

const useStyles = makeStyles((theme) => ({
  shiftTextLeft: {
    marginLeft: "90px",
  },
  shiftTextRight: {
    marginLeft: drawerWidth,
  },
  contentWrapper: {
    flex: 1,
    padding: "0",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
}));

export const AppRouter = withRouter(({ location }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const { authTokens, hasRole } = useAuth();
  const [isNavigationOpen, setNavigationOpen] = useState(
    !isMobile && getNavigationExpandedFromLocalStorage()
  );
  const classes = useStyles();

  return (
    <>
      <div className="navigationWrapper">
        {location.pathname.includes("login") ||
          (isMobile ? (
            <MobileNavigation
              width={drawerWidth}
              open={isNavigationOpen}
              setOpen={setNavigationOpen}
            />
          ) : (
            <Navigation
              width={drawerWidth}
              open={isNavigationOpen}
              setOpen={setNavigationOpen}
            />
          ))}
      </div>
      <div
        className={classNames(
          classes.contentWrapper,
          !isMobile &&
            (isNavigationOpen ? classes.shiftTextRight : classes.shiftTextLeft)
        )}
      >
        {authTokens && <NotificationDialog />}
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/driver_onboarding" component={DriverOnBoardingScreen} />

          <PrivateRoute
            path="/cars"
            exact
            component={CarsTable}
            allowedPrivileges={[CAR_READ]}
          />
          <PrivateRoute
            path="/cars/create"
            component={CreateCarForm}
            allowedPrivileges={[CAR_CREATE]}
          />
          <PrivateRoute
            path="/cars/edit/:id"
            component={EditCarForm}
            allowedPrivileges={[CAR_EDIT]}
          />
          <PrivateRoute
            path="/cars/details/:id/files/:fileId"
            component={CarDetails}
            allowedPrivileges={[CAR_READ]}
          />
          <PrivateRoute
            path="/cars/details/:id"
            component={CarDetails}
            allowedPrivileges={[CAR_READ]}
          />

          <PrivateRoute
            path="/drivers"
            exact
            component={DriversTable}
            allowedPrivileges={[DRIVER_READ]}
          />
          <PrivateRoute
            path="/drivers/create"
            component={CreateDriverForm}
            allowedPrivileges={[DRIVER_CREATE]}
          />
          <PrivateRoute
            path="/drivers/edit/:id"
            component={EditDriverForm}
            allowedPrivileges={[DRIVER_EDIT]}
          />
          <PrivateRoute
            path="/drivers/details/:id/files/:fileId"
            component={DriverDetails}
            allowedPrivileges={[DRIVER_READ]}
          />
          <PrivateRoute
            path="/drivers/details/:id"
            component={DriverDetails}
            allowedPrivileges={[DRIVER_READ]}
          />

          <PrivateRoute
            path="/contractors"
            exact
            component={ContractorsTable}
            allowedPrivileges={[CONTRACTOR_READ]}
          />
          <PrivateRoute
            path="/contractors/create"
            exact
            component={CreateContractorForm}
            allowedPrivileges={[CONTRACTOR_CREATE]}
          />
          <PrivateRoute
            path="/contractors/edit/:contractorId"
            exact
            component={EditContractorForm}
            allowedPrivileges={[CONTRACTOR_EDIT]}
          />
          <PrivateRoute
            path="/contractors/details/:contractorId"
            exact
            component={ContractorDetails}
            allowedPrivileges={[CONTRACTOR_READ]}
          />
          <PrivateRoute
            path="/contractors/edit-history/:contractorId"
            exact
            component={ContractorEditHistory}
            allowedPrivileges={[CONTRACTOR_READ]}
          />
          <PrivateRoute
            path="/contractors/:contractorId/policies/create"
            exact
            component={CreateInsurancePolicyForm}
            allowedPrivileges={[CONTRACTOR_CREATE]}
          />
          <PrivateRoute
            path="/contractors/:contractorId/policies/edit/:policyId"
            exact
            component={EditInsurancePolicyForm}
            allowedPrivileges={[CONTRACTOR_EDIT]}
          />

          <PrivateRoute
            path="/orders"
            exact
            component={OrdersTable}
            allowedPrivileges={[ORDER_READ]}
          />
          <PrivateRoute
            path="/orders/create"
            component={CreateOrder}
            allowedPrivileges={[ORDER_CREATE]}
          />
          <PrivateRoute
            path="/orders/edit/:orderId"
            component={EditOrder}
            allowedPrivileges={[ORDER_EDIT]}
          />
          <PrivateRoute
            path="/orders/details/:id/attachments/:attachmentId"
            component={OrdersDetails}
            allowedPrivileges={[ORDER_READ]}
          />
          <PrivateRoute
            path="/orders/details/:id/editHistory/:editId"
            component={OrderEditHistory}
            allowedPrivileges={[ORDER_HISTORY_READ]}
          />
          <PrivateRoute
            path="/orders/details/:id"
            component={OrdersDetails}
            allowedPrivileges={[ORDER_READ]}
          />

          <PrivateRoute
            path="/users"
            exact
            component={UsersTable}
            allowedPrivileges={[USER_READ]}
          />
          <PrivateRoute
            path="/users/create"
            component={CreateUserForm}
            allowedPrivileges={[USER_CREATE]}
          />
          <PrivateRoute
            path="/users/edit/:userId"
            component={EditUserForm}
            allowedPrivileges={[USER_EDIT]}
          />
          <PrivateRoute
            path="/users/details/:id"
            component={AdminUserDetailsView}
            allowedPrivileges={[USER_READ]}
          />
          <PrivateRoute
            path="/admin-panel"
            exact
            component={AdminPanelDetails}
            allowedPrivileges={[GLOBAL_CONFIGURATION_WRITE]}
          />
          <PrivateRoute
            path="/admin-panel/edit"
            exact
            component={AdminPanelForm}
            allowedPrivileges={[GLOBAL_CONFIGURATION_WRITE]}
          />

          <PrivateRoute
            path="/my-profile"
            component={MyProfile}
            allowedPrivileges={[MY_PROFILE_READ]}
          />

          <PrivateRoute
            path="/ferry-services"
            exact
            component={FerryServicesTable}
            allowedPrivileges={[FERRY_SERVICE_READ]}
          />
          <PrivateRoute
            path="/ferry-services/create"
            component={FerryServiceCreateForm}
            allowedPrivileges={[FERRY_SERVICE_CREATE]}
          />
          <PrivateRoute
            path="/ferry-services/details/:id"
            component={FerryServiceDetails}
            allowedPrivileges={[FERRY_SERVICE_READ]}
          />
          <PrivateRoute
            path="/ferry-services/edit/:id"
            component={FerryServiceEditForm}
            allowedPrivileges={[FERRY_SERVICE_EDIT]}
          />

          <PrivateRoute
            path="/custom-fields"
            exact
            component={CustomFieldsTable}
            allowedPrivileges={[CUSTOM_FIELDS_READ]}
          />
          <PrivateRoute
            path="/custom-fields/create"
            exact
            component={CustomFieldsCreateForm}
            allowedPrivileges={[CONTRACTOR_CREATE]}
          />
          <PrivateRoute
            path="/custom-fields/edit/:id"
            exact
            component={CustomFieldsEditForm}
            allowedPrivileges={[CONTRACTOR_EDIT]}
          />

          <PrivateRoute
            path="/user-groups"
            exact
            component={UserGroupsTable}
            allowedPrivileges={[USER_GROUP_READ]}
          />
          <PrivateRoute
            path="/user-groups/create"
            exact
            component={UserGroupsCreateForm}
            allowedPrivileges={[USER_GROUP_CREATE]}
          />
          <PrivateRoute
            path="/user-groups/edit/:id"
            exact
            component={UserGroupsEditForm}
            allowedPrivileges={[USER_GROUP_EDIT]}
          />

          <PrivateRoute
            path="/groups"
            exact
            component={GroupsTable}
            allowedPrivileges={[GROUP_READ]}
          />
          <PrivateRoute
            path="/groups/create"
            exact
            component={GroupsCreateForm}
            allowedPrivileges={[GROUP_CREATE]}
          />
          <PrivateRoute
            path="/groups/edit/:id"
            exact
            component={GroupsEditForm}
            allowedPrivileges={[GROUP_EDIT]}
          />

          <PrivateRoute path="/" component={MainPage} allowedPrivileges={[]} />

          <Redirect
            to={hasRole(UserRole.MobileUser) ? "/driver_onboarding" : "/"}
          />
        </Switch>
      </div>
    </>
  );
});
